// import { get } from "lodash";

export default {
  getPayoutsList: (state) => state.financials.payouts,
  getPayoutFilters: (state) => state.financials.payoutFilters,
  getPaymentMilestones: (state) => state.financials.paymentMilestones,
};
